import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { SalesAgency } from 'entities/sales_agency'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const salesAgencyColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'sales_agency_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '名称', th: true, minWidth: 150, form: form, orderAttr: 'sales_agency_name', searchType: { name: 'name', type: 'text' } },
            {
                name: '契約締結日',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'sales_agency_contract_date',
                searchType: { name: 'contract_date', type: 'date' },
            },
            {
                name: '有効期限タイプ',
                th: true,
                width: 180,
                form: form,
                orderAttr: 'sales_agency_expiration_type',
                searchType: { name: 'expiration_type', type: 'text' },
                align: 'center',
            },
            {
                name: '有効期限(年)',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'sales_agency_expiration_year',
                searchType: { name: 'expiration_year', type: 'number' },
                align: 'center',
            },
            {
                name: '有効期限(月)',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'sales_agency_expiration_month',
                searchType: { name: 'expiration_month', type: 'number' },
                align: 'center',
            },
            {
                name: '契約締結報酬',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'sales_agency_acquisition_reward',
                searchType: { name: 'acquisition_reward', type: 'number' },
                align: 'center',
            },
            {
                name: '売上マージン率',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'sales_agency_sales_margin',
                searchType: { name: 'sales_margin', type: 'number' },
                align: 'center',
            },
        ],
    }
}

export type SalesAgencyTableDataProps = {
    salesAgency?: SalesAgency
    displaySetting: DisplaySetting
}

export const SalesAgencyTableData = ({ salesAgency, displaySetting }: SalesAgencyTableDataProps): JSX.Element => {
    if (!salesAgency) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{salesAgency.id}</TableCell>
                <TableCell>{salesAgency.name}</TableCell>
                <TableCell>{toDateText(salesAgency.contractDate)}</TableCell>
                <TableCell align="center">
                    {salesAgency.expirationType === 'absolute' ? <Badge>営業代行の契約日基準</Badge> : <Badge bg="warning">医療機関の契約日基準</Badge>}
                </TableCell>
                <TableCell align="center">{salesAgency.expirationYear}年</TableCell>
                <TableCell align="center">{salesAgency.expirationMonth}月</TableCell>
                <TableCell align="center">{salesAgency.acquisitionReward?.toLocaleString()}円</TableCell>
                <TableCell align="center">{(salesAgency.salesMargin ?? 0) * 100}%</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
